import { render, staticRenderFns } from "./WebpackDashboard.vue?vue&type=template&id=589538b2&scoped=true"
import script from "./WebpackDashboard.vue?vue&type=script&lang=js"
export * from "./WebpackDashboard.vue?vue&type=script&lang=js"
import style0 from "./WebpackDashboard.vue?vue&type=style&index=0&lang=css"
import style1 from "./WebpackDashboard.vue?vue&type=style&index=1&id=589538b2&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589538b2",
  null
  
)

export default component.exports